import React, { useCallback } from "react";
import ReportingService from "Lib/API/reporting";
import { numberFormat } from "helper";
import moment from "moment/min/moment-with-locales";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";

const fmt = (n) => numberFormat({ number: n ?? 0, decimal: 2, style: "currency" });

const fmtDate = (d) => {
  if (!d) return "";
  return moment(d).format("MMM D");
};

const TYPE_MAP = {
  donation: "donation",
  membership: "membership",
  school: "school",
  "donation box": "donation",
  "membership fee": "membership",
  "school fee": "school",
};

const TYPE_LABEL = {
  donation: "Donation",
  membership: "Member",
  school: "School",
};

const pillClass = (type) => {
  const key = type ? TYPE_MAP[type.toLowerCase()] : null;
  return key ? `tx-pill tx-pill--${key}` : "tx-pill tx-pill--default";
};

const pillLabel = (type) => {
  if (!type) return "Other";
  const key = TYPE_MAP[type.toLowerCase()];
  return TYPE_LABEL[key] || type;
};

const RecentTransactionsWidget = ({ customizeMode, onRemove, onConfigure, dateRange, settings }) => {
  const filter = { ledger: settings?.ledger, subLedger: settings?.subLedger };
  const hasFilter = settings?.ledgerMeta?.length > 0;
  const fetcher = useCallback(
    (token) => ReportingService.getWidgetRecentTransactions(token, dateRange, filter),
    [dateRange, settings] // eslint-disable-line react-hooks/exhaustive-deps
  );
  const { data, loading, error, retry } = useWidgetData(fetcher);

  const txns = data?.transactions || [];
  const title = settings?.label || "Recent Transactions";

  return (
    <WidgetWrapper
      title={title}
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
      onConfigure={onConfigure}
    >
      {hasFilter && (
        <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 6 }}>
          {settings.ledgerMeta.map((m) => m.label).join(", ")}
        </div>
      )}
      {txns.length === 0 ? (
        <div className="list-widget__empty">No recent transactions</div>
      ) : (
        <div className="widget-scroll-list" style={{ maxHeight: 400 }}>
          {txns.map((t, i) => (
            <div key={i} className="list-widget__item" style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderTop: i === 0 ? "none" : "1px solid #E2E5EC" }}>
              <span className={pillClass(t.type)}>{pillLabel(t.type)}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="list-widget__primary" style={{ fontSize: 12.5 }}>{t.memberName || t.description}</div>
                <div className="list-widget__secondary">
                  {fmtDate(t.date)}
                  {t.ledger && (
                    <span style={{ marginLeft: 6, color: "#9ca3af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 300, display: "inline-block", verticalAlign: "bottom" }}>
                      · {t.subLedger || t.ledger}
                    </span>
                  )}
                </div>
              </div>
              <span className={`tx-amt tx-amt--${t.amount >= 0 ? "pos" : "neg"}`}>{fmt(Math.abs(t.amount))}</span>
            </div>
          ))}
        </div>
      )}
    </WidgetWrapper>
  );
};

export default RecentTransactionsWidget;
